<!-- DESKTOP LOGIN BUTTON -->
<button class="btn btn-primary btn-sm hide-lg" *forAuth="false" (click)="login()">
  {{ 'general_lang_login' | translate }}
</button>

<!-- MOBILE LOGIN BUTTON -->
<button class="btn btn-primary btn-sm show-lg" *forAuth="false" (click)="login()">
  <material-icon>person</material-icon>
</button>

<div class="dropdown dropdown-right" *forAuth>
  <a class="dropdown-toggle profile-dropdown-toggle" tabindex="0">
    <material-icon>how_to_reg</material-icon>
  </a>
  <ul class="menu text-left">
    <li class="menu-item">
      <a class="menu-link" (click)="goToProfile()">
        <material-icon>account_circle</material-icon>
        {{ 'label_my_account' | translate }}
      </a>
    </li>
    <li class="menu-item">
      <a class="menu-link" (click)="logout()">
        <material-icon>exit_to_app</material-icon>
        {{ 'general_lang_logout' | translate }}
      </a>
    </li>
    <li class="menu-item" *ngIf="currentAdminPartner">
      <a class="menu-link admin-partner current-partner" href="{{ getAdminSiteUrl(currentAdminPartner.partnerId, true) }}">
        <i>{{ currentAdminPartner.name | partnerMonogram }}</i>
        {{ currentAdminPartner.name }}
      </a>
    </li>
    <li class="menu-item" *ngFor="let partner of availableAdminPartners">
      <a class="menu-link admin-partner" href="{{ getAdminSiteUrl(partner.partnerId, true) }}">
        <i>{{ partner.name | partnerMonogram }}</i>
        {{ partner.name }}
      </a>
    </li>
  </ul>
</div>
